import React from 'react';
import SrSimpleMessageModal, {
  SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP,
} from 'client/components/SrSimpleMessageModal/SrSimpleMessageModal';
import { SR_BUTTON_THEME_ADOBE_GREEN } from 'client/components/SrButton/SrButton';

const SrUtilitySetupSetInternetModal = ({ utilityType, onConfirm }) => {
  return (
    <SrSimpleMessageModal
      iconUrl={utilityType.iconUrl}
      maxIconHeight="50px"
      maxIconWidth="50px"
      iconBgColor={utilityType.iconBackgroundColor}
      contentContainerClassName="utilityProviderContact"
      headline={`${utilityType.label} setup completed!`}
      maxWidth={400}
      theme={SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP}
      srMultiButtons={[
        {
          buttonText: 'Next: Internet',
          onButtonClick: onConfirm,
          buttonTheme: SR_BUTTON_THEME_ADOBE_GREEN,
        },
      ]}
    />
  );
};

export default SrUtilitySetupSetInternetModal;
